import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import CampaignIcon from "@mui/icons-material/Campaign";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

export default function BecomeEntrepreneurPage() {
  return (
    <Box sx={{ backgroundColor: "#f8f8f8", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="lg">
        {/* Sayfa Başlığı */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
            Nasıl Girişimci Olunur
          </Typography>
          <Typography variant="h6" sx={{ color: "#555", lineHeight: 1.8 }}>
            Girişiminizi Hızlı, Zahmetsiz, Teminatsız ve Faizsiz Finansmanla Hızlandırın
          </Typography>
        </Box>

        {/* Bilgilendirme Kartları */}
        <Grid container spacing={4}>
          {/* Platforma Katıl */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <PersonAddAltIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Platforma Katıl
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                E-posta ve cep telefonunuzla kolayca kaydolun. Profil doğrulama adımlarını tamamladıktan sonra kampanya başlatmaya hazırsınız.
              </Typography>
            </Box>
          </Grid>

          {/* Kampanya Başlat */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <CampaignIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Kampanya Başlat
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                Kampanya formlarını doğru ve kapsamlı bir şekilde doldurun. Bilgilerinizi girerken sol menüdeki 'Ön İzle' seçeneğini kullanarak girişiminizi yatırımcıların gözüyle değerlendirin.
              </Typography>
            </Box>
          </Grid>

          {/* Girişiminizi Yükseltin */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <RocketLaunchIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Girişiminizi Yükseltin
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                Kampanyanız onaylandıktan sonra, Yatırım Komitesi ile tanıtım faaliyetlerinizi planlayacağız. Tanıtımınız dijital ve geleneksel medyada desteklenecektir.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Görsel ve Ek Bilgi */}
        <Box sx={{ mt: 8, textAlign: "center" }}>
          <Grid container spacing={4} alignItems="center">
            {/* Görsel */}
            <Grid item xs={12} md={6}>
              <img
                src="/img/angel-invest.jpeg" // Görsel yolu
                alt="Girişimci Olma Süreci"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </Grid>

            {/* Bilgi */}
            <Grid item xs={12} md={6} sx={{ mt: 8, textAlign: "left" }}>
              <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4, color: "#1769aa" }}>
                Girişimci Olma Süreci
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                Ardventure platformu, girişiminizi hızlandırmanız ve yatırımcılarla buluşmanız için ihtiyacınız olan tüm süreçleri kolaylaştırır. Girişimcilik yolculuğunuzu destekliyoruz.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 4,
                  backgroundColor: "#1769aa",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#145a8c",
                  },
                }}
              >
                Daha Fazla Bilgi
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}